import { createState, State } from '@hookstate/core';
import { createContext } from 'react';

export const correctAnswerContext = createContext<State<Record<string, unknown>>>(createState<Record<string, unknown>>({}));
